import { render, staticRenderFns } from "./EmailFooter.vue?vue&type=template&id=4b9ca109"
import script from "./EmailFooter.vue?vue&type=script&lang=js"
export * from "./EmailFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b9ca109')) {
      api.createRecord('4b9ca109', component.options)
    } else {
      api.reload('4b9ca109', component.options)
    }
    module.hot.accept("./EmailFooter.vue?vue&type=template&id=4b9ca109", function () {
      api.rerender('4b9ca109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminders/EmailFooter.vue"
export default component.exports